"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTechnicalErrorMessage = exports.unauthorizedError = exports.getNotNullNumber = exports.getNotNullString = void 0;
var getNotNullString = function (obj) {
    return obj ? obj : "";
};
exports.getNotNullString = getNotNullString;
var getNotNullNumber = function (obj) {
    return obj ? obj : 0;
};
exports.getNotNullNumber = getNotNullNumber;
/**
 * Petite méthode pour vérifier si l'erreur catché suite a une requete avec axios a obtenue une 401 (UNAUTORIZED)
 * @param e L'erreur catché à la suite du requete aec Axios
 */
var unauthorizedError = function (e) {
    var _a, _b;
    if (e && !e["response"]) {
        return false;
    }
    var res = ((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) && ((_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) === 401;
    return res;
};
exports.unauthorizedError = unauthorizedError;
var buildTechnicalErrorMessage = function (e) {
    var _a, _b;
    if (e && !e["response"]) {
        return { statusCode: -1, message: JSON.stringify(e) };
    }
    var res = {
        statusCode: (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
        message: (e === null || e === void 0 ? void 0 : e.toJSON()) ? e === null || e === void 0 ? void 0 : e.toJSON() : "error object is null or undefined"
    };
    return res;
};
exports.buildTechnicalErrorMessage = buildTechnicalErrorMessage;
